const TIME_OF_DAY_REGEXP = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export const isValidTimeOfDay = (value: string | null): value is string =>
  !!value && TIME_OF_DAY_REGEXP.test(value);

const timeOfDayToMinutes = (value: string): number => {
  const [hours, minutes] = value.split(':').map(Number);

  return hours * 60 + minutes;
};

export const isTimeOfDayBefore = (
  start: string | null,
  end: string | null
): boolean => {
  if (!isValidTimeOfDay(start) || !isValidTimeOfDay(end)) {
    return false;
  }

  return timeOfDayToMinutes(start) < timeOfDayToMinutes(end);
};
